import type { SettingsSectionProps } from '../types';

export interface DocumentLibrarySettings {
  documentTypes: string[];
  classifications: string[];
  businessUnits: string[];
}

export interface AuditSettings {
  findingTypes: string[];
  riskCategories: string[];
}

export interface MenuSettings {
  documentLibrary: DocumentLibrarySettings;
  audit: AuditSettings;
  // Add other menu settings here as needed
}

export const defaultMenuSettings: MenuSettings = {
  documentLibrary: {
    documentTypes: [
      'Policy', 
      'Procedure', 
      'Form', 
      'Evidence', 
      'Matrix', 
      'Checklist', 
      'Standard', 
      'Confluence Page'
    ],
    classifications: ['Customer Confidential', 'Business Confidential', 'Public'],
    businessUnits: ['Management', 'Operations', 'Development', 'Finance']
  },
  audit: {
    findingTypes: [
      'OFI',
      'Minor NC',
      'Major NC'
    ],
    riskCategories: [
      'Strategic Risk',
      'Operational Risk',
      'Financial Risk',
      'Compliance Risk',
      'Reputational Risk',
      'Technology Risk',
      'Security Risk'
    ]
  }
};

// No additional props needed for now, using base SettingsSectionProps
